import { isObject, size } from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { notify, TYPE } from "@8x8/oxygen-toaster";

import {
  selectSkipNextSync,
  setCustomer,
  setPbxId,
  setReactCustomer,
  setSkipNextSync,
  setTenantId,
} from "./customerSlice";
import clearCustomer from "./clearCustomer";
import mapToReactCustomerData from "./mapToReactCustomerData";

const applyVueCustomer = createAsyncThunk(
  "customer/applyVueCustomer",
  async (customerData, { getState, dispatch }) => {
    const state = getState();
    const skipNextSync = selectSkipNextSync(state);
    if (skipNextSync) {
      console.debug("Skipping one Vue->React sync.");

      // We skip this Vue->React sync since otherwise it would generate a
      // double update. See {@see customerSlice.js}.
      dispatch(setSkipNextSync(false));
      return;
    }

    if (
      customerData == null ||
      !isObject(customerData) ||
      !size(customerData)
    ) {
      dispatch(clearCustomer());
      return;
    }

    try {
      dispatch(setCustomer(customerData));

      // "reactCustomer" needs a transformer applied before being set
      const reactCustomer = mapToReactCustomerData(customerData);
      dispatch(setReactCustomer(reactCustomer));

      if (customerData?.pbx) {
        const pbx = customerData?.pbx ?? {};
        const pbxId = pbx?.id;

        if (pbxId !== reactCustomer.preselectedPbxId) {
          throw new Error(
            "Data inconsistency - PBX and reactCustomer will be out of sync." +
              JSON.stringify({
                pbxId,
                preselectedPbxId: reactCustomer.preselectedPbxId,
              })
          );
        }

        dispatch(setPbxId(pbxId));
      }

      const tenantInfo = customerData?.tenantInfo ?? [];
      const firstTenant = tenantInfo?.[0];
      if (firstTenant) {
        const tenantId = firstTenant?.tenantId;
        dispatch(setTenantId(tenantId));
      }
    } catch (e) {
      if (e instanceof Error) {
        console.error("Error during setting customer received from Vue.", e);
      }

      notify({
        type: TYPE.error,
        content: "Failed to sync customer data with Vue. Check logs.",
        duration: 5000,
      });
    }
  }
);

export default applyVueCustomer;
